function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function computeSliceDdaModifier(progress01: number, currentArmy: number, expectedArmy: number): number {
  const clampedProgress = clamp(progress01, 0, 1);

  if (clampedProgress >= 0.8) {
    return 1;
  }

  const expected = Math.max(1, expectedArmy);
  const ratio = currentArmy / expected;

  if (ratio < 0.7) {
    const t = clamp((0.7 - ratio) / 0.35, 0, 1);
    return 1 - 0.25 * t;
  }

  if (ratio > 1.3) {
    const t = clamp((ratio - 1.3) / 0.8, 0, 1);
    return 1 + 0.15 * t;
  }

  return 1;
}

export function lockBarrierHpAtSpawn(baseHp: number, ddaModifier: number): number {
  return Math.max(1, Math.round(baseHp * ddaModifier));
}
